
/* styles */
require("!!vue-style-loader!css-loader?minimize!../../node_modules/vue-loader/lib/style-rewriter?id=data-v-2647fcf4!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./MenuDireita.vue")

var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./MenuDireita.vue"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-2647fcf4!../../node_modules/vue-loader/lib/selector?type=template&index=0!./MenuDireita.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/MenuDireita.vue
// module id = 79
// module chunks = 0